import Post1Image1 from "../images/_olds/posts-images/post1-1.jpg";
import Post2Image1 from "../images/_olds/posts-images/post2-1.png";
import Post3Image1 from "../images/_olds/posts-images/post3-1.jpg";
import Post4Image1 from "../images/_olds/posts-images/post4-1.jpg";
import Post5Image1 from "../images/_olds/posts-images/post5-1.jpg";
import Post5Image2 from "../images/_olds/posts-images/post5-2.jpg";
import Post6Image1 from "../images/_olds/posts-images/post6-1.jpg";
import Post7Image1 from "../images/_olds/posts-images/post7-1.jpg";
import Post8Image1 from "../images/_olds/posts-images/post8-1.jpg";
import Post9Image1 from "../images/_olds/posts-images/post9-1.jpg";
import Post10Image1 from "../images/_olds/posts-images/post10-1.jpg";
import Post11Image1 from "../images/_olds/posts-images/post11-1.jpg";
import Post11Image2 from "../images/_olds/posts-images/post11-2.jpg";
import Post11Image3 from "../images/_olds/posts-images/post11-3.jpg";
import Post11Image4 from "../images/_olds/posts-images/post11-4.jpg";
import Post12Image1 from "../images/_olds/posts-images/post12-1.jpg";
import Post12Image2 from "../images/_olds/posts-images/post12-2.jpg";
import Post13Image1 from "../images/_olds/posts-images/post13-1.jpg";
import Post13Image2 from "../images/_olds/posts-images/post13-2.jpg";
import Post14Image1 from "../images/_olds/posts-images/post14-1.jpg";
import Post15Image1 from "../images/_olds/posts-images/post15-1.png";
import Post16Image1 from "../images/_olds/posts-images/post16-1.jpg";

export const InsightsPosts = [
  {
    id: 1,
    title: "Tendência de publicações sobre RWE ou RWD nos últimos 20 anos",
    description:
      "Ao analisar o total de referências obtidas em uma busca simples no PubMed, utilizando termos de RWE ou RWD, podemos observar que houve um aumento...",
    cover: Post1Image1,
    paragraphs: [
      {
        text: "Ao analisar o total de referências obtidas em uma busca simples no PubMed, utilizando termos de RWE ou RWD, podemos observar que houve um aumento exponencial no total de publicações envolvendo esses termos ao longo dos últimos 10 anos.",
        type: "text",
      },
      {
        text: Post1Image1,
        type: "image",
      },
      {
        text: "Também é interessante observar que, nos primeiros 6 meses de  2024, já foi ultrapassada a marca de 50% de publicações em comparação a 2023: 61% até o dia 1º de julho, considerando o total do ano passado (2024/2023). O que nos indica que neste ano seguiremos com um incremento positivo em comparação aos anos anteriores!",
        type: "text",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 2,
    title: "Aceitação de #RWE em HTA no mundo",
    description:
      "Ótimo artigo, recentemente publicado, o qual revisou o uso e aceitação de RWE por agências de HTA ao redor do mundo.",
    cover: Post2Image1,
    paragraphs: [
      {
        text: Post2Image1,
        type: "image",
      },
      {
        text: "Ótimo artigo, recentemente publicado, o qual revisou o uso e aceitação de RWE por agências de HTA ao redor do mundo.",
        type: "text",
      },
      {
        text: "Principais highlights:",
        type: "list",
        list: [
          "• As agências de ATS normalmente solicitavam análises baseadas em fontes de dados locais, mas o desenho de estudo preferido e as fontes de dados diferiram.",
          "• As agências possuem processos de submissão, avaliação e análise crítica; algumas permitem reuniões preliminares para validação do protocolo e/ou resultados, embora poucas envolvam especialistas externos ou sociedades médicas para fornecer inputs potencialmente relevantes.",
          "• A extensão dos requisitos de submissão, avaliação e análise crítica não refletia necessariamente o grau de aceitação desse tipo de evidência. ",
        ],
      },
      {
        text: "Acesse aqui o artigo completo:",
        type: "link",
        link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC11130860/",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 3,
    title: "Ecossistema de dados e acessibilidade a RWD",
    description:
      "Soluções técnicas e investimento são necessários para tornar o uso de RWD mais prático e acessível.",
    cover: Post3Image1,
    paragraphs: [
      {
        text: "Soluções técnicas e investimento são necessários para tornar o uso de RWD mais prático e acessível.",
        type: "text",
      },
      {
        text: "Nesse sentido, recomendamos a leitura de um artigo recentemente publicado, sobre a criação do Stanford Population Health Sciences Data Ecosystem, um ecossistema de dados criado para abrigar, administrar e compartilhar RWD em ambiente acadêmico.",
        type: "text",
      },
      {
        text: "O artigo contempla três tópicos principais:",
        type: "list",
        list: [
          "• Benefícios e desafios do uso de RWD para pesquisa translacional;",
          "• Discussão de como abordar os desafios pelo desenvolvimento de um ecossistema de dados para utilização de RWD no contexto acadêmico, que garanta maior utilidade dos dados, apresentando as estratégias seguidas para a criação de uma solução que seja replicável e acessível para organizações interessadas em utilizar dados de alto valor e alto risco de forma segura, escalável e confiável;",
          "• Próximos passos e para aumentar o impacto de RWD para solução de problemas de saúde populacional e equidade em saúde, e formas de facilitar o uso desses dados para ciência translacional.",
        ],
      },
      {
        text: Post3Image1,
        type: "image",
      },
      {
        text: "Você pode acessar o artigo na íntegra aqui:",
        type: "link",
        link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC11148826/",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 4,
    title:
      "Agência Europeia de Medicamentos (EMA) e uso de RWE na tomada de decisões em saúde",
    description:
      "Destacamos essa revisão que apresenta a experiência da EMA para gerar RWE como apoio para tomadas de decisões (setembro de 2021 a fevereiro de 2023).",
    cover: Post4Image1,
    paragraphs: [
      {
        text: "Destacamos essa revisão que apresenta a experiência da EMA para gerar RWE como apoio para tomadas de decisões (setembro de 2021 a fevereiro de 2023).",
        type: "text",
      },
      {
        text: "Um total de 61 tópicos de investigação foram identificados para a geração de RWE durante este período, abrangendo uma ampla gama de questões de pesquisa, gerando principalmente evidências sobre:",
        type: "list",
        list: [
          "1. Segurança dos medicamentos (22, 36%)",
          "2. Desenho e a viabilidade de ECR (11, 18%)",
          "3. Utilização de medicamentos (10, 16%)",
          "4. Manejo clínico (10, 16%)",
          "5. Epidemiologia da doença (7, 11%)",
        ],
      },
      {
        text: Post4Image1,
        type: "image",
      },
      {
        text: "A maioria dos estudos foram descritivos e tiveram como objetivo estimar taxas de incidência e prevalência de desfechos clínicos, incluindo eventos adversos, ou avaliar a utilização de medicamentos.",
        type: "text",
      },
      {
        text: "Acesse aqui o artigo completo:",
        type: "link",
        link: "https://ascpt.onlinelibrary.wiley.com/doi/epdf/10.1002/cpt.3355",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 5,
    title: "Biomarcadores oncológicos e RWE",
    description:
      "A indústria de diagnóstico molecular tem confiado historicamente em ensaios clínicos e fontes de dados comoditizadas para informar seu processo de descoberta e validação de biomarcadores.",
    cover: Post5Image1,
    paragraphs: [
      {
        text: "A indústria de diagnóstico molecular tem confiado historicamente em ensaios clínicos e fontes de dados comoditizadas para informar seu processo de descoberta e validação de biomarcadores.",
        type: "text",
      },
      {
        text: "Em um esforço para obter informações mais precisas sobre a experiência do paciente e trazer biomarcadores inovadores para o mercado com mais eficiência e precisão, a indústria está agora se expandindo para dados ampliados do mundo real.",
        type: "text",
      },
      {
        text: Post5Image1,
        type: "image",
      },
      {
        text: "Destacamos hoje um artigo onde os autores trazem insights sobre como as empresas de diagnóstico devem colaborar com um parceiro de análise de dados de saúde na busca de três ativos principais:",
        type: "list",
        list: [
          "1. Megadados amplos e complexos com metadados",
          "2. Rede de provedores de dados",
          "3. Mecanismo de melhoria de resultados ",
        ],
      },
      {
        text: "Três elementos chaves para apoiar a próxima geração de desenvolvimento de diagnóstico molecular (Dx) e terapêutica (Rx).",
        type: "text",
      },
      {
        text: Post5Image2,
        type: "image",
      },
      {
        text: "Acesse aqui o artigo na íntegra:",
        type: "link",
        link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC10205392/",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 6,
    title: "Plano de dados abertos do Ministério da Saúde (2024-2026)",
    description:
      "Dados abertos consistem em bases de dados públicas, disponibilizadas ativamente na internet para uso geral, sendo fontes de RWD fundamentais para análises de RWE. Esses dados são oferecidos em formatos de arquivo não proprietários, promovendo maior transparência pública.",
    cover: Post6Image1,
    paragraphs: [
      {
        text: "Dados abertos consistem em bases de dados públicas, disponibilizadas ativamente na internet para uso geral, sendo fontes de RWD fundamentais para análises de RWE. Esses dados são oferecidos em formatos de arquivo não proprietários, promovendo maior transparência pública.",
        type: "text",
      },
      {
        text: "O documento publicado pelo Ministério da Saúde define as ações necessárias para a implementação e promoção da abertura de dados pelo período de dois anos, a partir de julho de 2024, e sua importância para a transparência e publicidade dos dados sob a responsabilidade do MS.",
        type: "text",
      },
      {
        text: Post6Image1,
        type: "image",
      },
      {
        text: "Principais seções do PDA-MS:",
        type: "list",
        list: [
          "• Cenário institucional: O documento descreve a estrutura e responsabilidades do Ministério da Saúde, incluindo a criação da Secretaria de Informação e Saúde Digital (SEIDIGI) e suas subdivisões.",
        ],
      },
      {
        text: "Objetivos:",
        type: "list",
        list: [
          "• Geral: Promover a abertura de dados com transparência e eficiência, aumentando a disseminação de informações à sociedade e melhorando a qualidade dos dados.",
          "• Específicos: Identificar prioridades, melhorar a gestão e a qualidade dos dados, incrementar processos de transparência e estimular o desenvolvimento de aplicações pela sociedade civil.",
          "• Construção e execução do plano: O texto detalha as etapas e ações realizadas para a elaboração do plano, incluindo a formação de equipes, elaboração de cartilhas, consulta pública, oficinas e aplicação de critérios de priorização para abertura de bases de dados.",
          "• Dados selecionados para abertura: Define critérios para a priorização das bases de dados, como relevância para o cidadão, estímulo ao controle social, obrigatoriedade legal e capacidade de fomento ao desenvolvimento sustentável.",
          "• Processo de catalogação: Explica como os dados serão catalogados e publicados no Portal Brasileiro de Dados Abertos (https://dados.gov.br/home).",
          "• Sustentabilidade e monitoramento: Descreve como será feita a comunicação, participação social e monitoramento da execução do plano, garantindo a qualidade e periodicidade da abertura dos dados.",
          "• Plano de ação: Organiza as ações a serem realizadas em três dimensões: elaboração e sustentação do PDA-MS, abertura das bases de dados e promoção do uso e reuso das bases de dados do Ministério da Saúde.",
        ],
      },
      {
        text: "Acesse aqui o documento:",
        type: "link",
        link: "https://www.gov.br/saude/pt-br/acesso-a-informacao/dados-abertos/pda/plano-de-dados-abertos_ms_2024-2026.pdf/view",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 7,
    title:
      "RWE no processo de aprovações aceleradas do FDA e decisões de cobertura",
    description:
      "Pesquisadores do Duke-Margolis Institute for Health Policy publicaram ao final de julho deste ano um White Paper sobre o cenário de uso de RWD como parte do pacote de evidências para informar tanto reguladores como pagadores na avaliação de tecnologias dentro do processo de aprovação acelerada do FDA. ",
    cover: Post7Image1,
    paragraphs: [
      {
        text: "Pesquisadores do Duke-Margolis Institute for Health Policy publicaram ao final de julho deste ano um White Paper sobre o cenário de uso de RWD como parte do pacote de evidências para informar tanto reguladores como pagadores na avaliação de tecnologias dentro do processo de aprovação acelerada do FDA. ",
        type: "text",
      },
      {
        text: Post7Image1,
        type: "image",
      },
      {
        text: "O processo de aprovação acelerado é geralmente indicado para certas doenças com opções limitadas de tratamento, incluindo doenças raras e algumas formas de câncer. Nesses casos, o uso de RWD pode suprir a necessidade de evidências mais rápidas e dar suporte à tomada de decisão.",
        type: "text",
      },
      {
        text: "Os pesquisadores abordam três casos de uso: ",
        type: "list",
        list: [
          "• Elevidys para distrofia muscular de Duchenne, com RWD/RWE submetida na avaliação inicial de aprovação;",
          "• Vijoice para o espectro de hipercrescimento associado ao gene PIK3CA (PROS), com RWD/RWE considerada dentro do pacote de evidências para aprovação acelerada;",
          "• Keytruda para carcinoma de células de Merkel, com RWD/RWE potencialmente gerando evidências confirmatórias pós comercialização.",
        ],
      },
      {
        text: "Frente aos casos avaliados, os autores discutem sobre a seleção de desfechos, capacidade de generalização e representatividade de estudos de RWD além do uso de registros e repositórios de dados, braço de controle externo e considerações para pagadores privados.",
        type: "text",
      },
      {
        text: "Acesse e leia o documento completo aqui:",
        type: "link",
        link: "https://healthpolicy.duke.edu/publications/applying-real-world-data-and-real-world-evidence-accelerated-approvals-and-coverage",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 8,
    title:
      "Uso de dados e evidências de mundo real nos Estados Unidos e na União Europeia",
    description:
      "O artigo 'Real-World Data and Real-World Evidence in Healthcare in the United States and Europe Union' de Kelly H. Zou e Marc L. Berger, publicado em agosto de 2024, aborda o uso de dados do mundo real (RWD) e evidências do mundo real (RWE) na tomada de decisões em saúde, tanto nos Estados Unidos quanto na União Europeia.",
    cover: Post8Image1,
    paragraphs: [
      {
        text: "O artigo 'Real-World Data and Real-World Evidence in Healthcare in the United States and Europe Union' de Kelly H. Zou e Marc L. Berger, publicado em agosto de 2024, aborda o uso de dados do mundo real (RWD) e evidências do mundo real (RWE) na tomada de decisões em saúde, tanto nos Estados Unidos quanto na União Europeia.",
        type: "text",
      },
      {
        text: "Desafios e oportunidades:",
        type: "list",
        list: [
          "• O artigo discute a complexidade do uso de RWD para a tomada de decisões em saúde, destacando a necessidade de frameworks abordando critérios sobre a qualidade de dados para assegurar que os RWD sejam adequados.",
          "• A transparência na curadoria e análise de RWD é crucial, assim como a interoperabilidade dos sistemas e a proteção de dados sensíveis.",
        ],
      },
      {
        text: "Impacto regulatório:",
        type: "list",
        list: [
          "• Tanto nos EUA quanto na UE, há esforços regulatórios para incorporar o uso de RWE na avaliação da eficácia e segurança de tratamentos.",
          "• O artigo descreve frameworks de qualidade de dados utilizados por órgãos reguladores, como a FDA nos EUA e a EMA na UE.",
        ],
      },
      {
        text: "Futuro de RWD e RWE:",
        type: "list",
        list: [
          "• O uso de RWD e RWE deve crescer, especialmente com os avanços em saúde digital e inteligência artificial.",
          "• No entanto, a aceitação regulatória desses dados requer que sejam abordadas questões como a validade e a confiabilidade dos métodos de curadoria e análise de dados.",
        ],
      },
      {
        text: Post8Image1,
        type: "image",
      },
      {
        text: "Acesse o artigo completo aqui:",
        type: "link",
        link: "https://www.mdpi.com/2306-5354/11/8/784",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 9,
    title:
      "Dados clínicos e administrativos de seguradora de saúde como fonte de RWD no Brasil",
    description:
      "Dados administrativos são uma das fontes clássicas de RWD, entre elas destacam-se as bases de dados administrativos em saúde públicas e privadas.",
    cover: Post9Image1,
    paragraphs: [
      {
        text: "Dados administrativos são uma das fontes clássicas de RWD, entre elas destacam-se as bases de dados administrativos em saúde públicas e privadas.",
        type: "text",
      },
      {
        text: "Estudo quentinho, com uso de dados de mais de 17 mil pacientes de uma seguradora de saúde nacional analisa os níveis de colesterol LDL e custos de tratamento de pacientes com e sem aterosclerose.",
        type: "text",
      },
      {
        text: "Alguns pontos de destaque:",
        type: "list",
        list: [
          "• A partir de uma base com mais de 6 milhões de pacientes distintos, foram selecionados pacientes com 18+ anos que apresentassem ao menos um resultado de exame de colesterol em prontuário eletrônico em uma das unidades ambulatoriais da seguradora entre 2015 e 2017;",
          "• Foram aplicados algoritmos de inteligência artificial (processamento de linguagem natural - PLN) para análise dos dados não estruturados referentes aos resultados de exames de colesterol LDL;",
          "• Os pacientes incluídos foram classificados quanto à presença ou ausência de aterosclerose, com avaliação de custo de tratamento hospitalar e ambulatorial em 1 ano.",
        ],
      },
      {
        text: Post9Image1,
        type: "image",
      },
      {
        text: "Acesse a publicação completa aqui:",
        type: "link",
        link: "https://globalheartjournal.com/articles/10.5334/gh.1345",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 10,
    title:
      "Emulated Target Trials: Usando RWD para emular ensaios clínicos randomizados hipotéticos",
    description:
      "A resistência ao uso de RWE para inferência causal se deve aos vieses relacionados à falta de randomização, incluindo a incerteza quanto à alocação da intervenção e seu momento de início.",
    cover: Post10Image1,
    paragraphs: [
      {
        text: "A resistência ao uso de RWE para inferência causal se deve aos vieses relacionados à falta de randomização, incluindo a incerteza quanto à alocação da intervenção e seu momento de início.",
        type: "text",
      },
      {
        text: "Uma forma de reduzir esses vieses é desenhar os estudos de RWD de forma que emulem explicitamente um ensaio clínico randomizado hipotético que responderia a pergunta de pesquisa de interesse, um 'target trial'.",
        type: "text",
      },
      {
        text: "Nossa sugestão de leitura da semana é de um estudo publicado este mês, sobre o efeito de colchicina para redução de risco cardiovascular e periférico em pacientes com doença arterial periférica e gota. ",
        type: "text",
      },
      {
        text: "A publicação descreve dois target trials emulados com dados de beneficiários do Medicare:",
        type: "list",
        list: [
          "• Comparação da colchicina com o uso de anti-inflamatórios não esteroides (AINEs) ao iniciar terapia de redução de urato, estimando o análogo observacional de um efeito por intenção-de-tratar;",
          "• Comparação de tratamento com colchicina de longa duração (tempo indeterminado) e curta duração (90 dias), estimando um efeito por protocolo, com métodos que evitam viés de tempo imortal e com ajuste de confundimento variável no tempo.",
        ],
      },
      {
        text: Post10Image1,
        type: "image",
      },
      {
        text: "O desfecho primário de ambos os estudos foi uma composição de qualquer evento adverso cardiovascular maior (MACE), evento adverso maior em membros (MALE) ou mortalidade por todas as causas em 2 anos.",
        type: "text",
      },
      {
        text: "Saiba mais acessando a publicação completa aqui:",
        type: "link",
        link: "https://academic.oup.com/ehjopen/article/4/4/oeae062/7732873?login=false",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 11,
    title: "TruEvidence no FAFF 2024!",
    description:
      "A TruEvidence esteve presente no XII Fórum Brasileiro sobre Assistência Farmacêutica e Farmacoeconomia, realizado em São Paulo, de 16 a 20 de setembro, com a apresentação oral de dois trabalhos, concorrendo a premiação:",
    cover: Post11Image4,
    paragraphs: [
      {
        text: "A TruEvidence esteve presente no XII Fórum Brasileiro sobre Assistência Farmacêutica e Farmacoeconomia, realizado em São Paulo, de 16 a 20 de setembro, com a apresentação oral de dois trabalhos, concorrendo a premiação:",
        type: "text",
      },
      {
        text: Post11Image1,
        type: "image",
      },
      {
        text: Post11Image2,
        type: "image",
      },
      {
        text: "Acompanhe com a sócia-diretora da TruEvidence, Karlyse  C. Belli, mais sobre o dia das apresentações:",
        type: "text",
      },
      {
        text: "https://www.youtube.com/shorts/EvyJnBk2Mv4",
        type: "video",
      },
      {
        text: "Nossas análises e resultados de RWE sobre os custos indiretos da Esclerose Múltipla nos últimos 10 anos de benefícios concedidos pelo INSS ganhou o 1º lugar na categoria Gestão do XII Fórum Brasileiro sobre Assistência Farmacêutica e Farmacoeconomia.",
        type: "text",
      },
      {
        text: Post11Image3,
        type: "image",
      },
      {
        text: Post11Image4,
        type: "image",
      },
      {
        text: "Saiba mais sobre o objetivo e resultados obtidos no estudo premiado:",
        type: "text",
      },
      {
        text: "https://youtube.com/shorts/1bQ_OjxedYQ",
        type: "video",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 12,
    title: "O papel dos controles externos no desenvolvimento de medicamentos",
    description:
      "Um artigo da Value & Outcomes Spotlight destaca que, embora os ensaios clínicos randomizados (RCT) sejam o padrão-ouro para a tomada de decisões regulatórias, os controles externos (ECAs) são ferramentas valiosas em certos contextos. ",
    cover: Post12Image1,
    paragraphs: [
      {
        text: "Um artigo da Value & Outcomes Spotlight destaca que, embora os ensaios clínicos randomizados (RCT) sejam o padrão-ouro para a tomada de decisões regulatórias, os controles externos (ECAs) são ferramentas valiosas em certos contextos. ",
        type: "text",
      },
      {
        text: Post12Image1,
        type: "image",
      },
      {
        text: "Seguem alguns dos insights discutidos pelos autores sobre os ECAs:",
        type: "list",
        list: [
          "1. Papel dos ECAs: Os ECAs são usados como alternativas aos RCTs em contextos em que há limitações de recrutamento de pacientes ou falta de tratamento disponível para doenças graves. Eles são baseados em dados de fontes externas (RWD), como registros médicos ou estudos anteriores.",
          "2. Vantagens dos ECAs: Os ECAs podem acelerar o desenvolvimento de medicamentos, reduzir custos e fornecer insights sobre a eficácia de novos tratamentos, especialmente em cenários onde os RCTs são inviáveis.",
          "3. Considerações metodológicas: Para garantir o sucesso dos ECAs, é crucial um planejamento rigoroso e justificativa clara para seu uso. A seleção adequada das fontes de dados e o controle de vieses como confusão e viés de seleção são fundamentais.",
          "4. Aplicação em Casos Reais: ECAs são especialmente úteis em doenças raras ou fatais, permitindo que decisões regulatórias e terapêuticas sejam tomadas com mais rapidez e baseadas em evidências robustas.",
          "",
          "",
        ],
      },
      {
        text: Post12Image2,
        type: "image",
      },
      {
        text: "Texto completo disponível aqui:",
        type: "link",
        link: "https://www.ispor.org/docs/default-source/publications/value-outcomes-spotlight/ispor_vos_august-2024_final.pdf?sfvrsn=8d3d2033_1",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 13,
    title: "RWE & prevenção do câncer de mama",
    description:
      "Em referência ao Outubro Rosa, sugerimos a leitura de um estudo que avalia fatores que influenciam a aderência a um programa multicêntrico francês de gerenciamento de risco para mulheres com predisposição genética a câncer de mama (portadoras dos genes BRCA1 ou BRCA2).",
    cover: Post13Image2,
    paragraphs: [
      {
        text: "Em referência ao Outubro Rosa, sugerimos a leitura de um estudo que avalia fatores que influenciam a aderência a um programa multicêntrico francês de gerenciamento de risco para mulheres com predisposição genética a câncer de mama (portadoras dos genes BRCA1 ou BRCA2).",
        type: "text",
      },
      {
        text: "Esse estudo analisa RWD de 778 mulheres acompanhadas por uma mediana de 4,7 anos em 4 regiões francesas pelo programa de vigilância Phare Grand Ouest, avaliando a extensão na qual as mulheres foram pontuais com o protocolo de rastreamento (considerando uma margem de tolerância para o atraso), e fatores associados à aderência a esses protocolos.",
        type: "text",
      },
      {
        text: Post13Image1,
        type: "image",
      },
      {
        text: "Alguns resultados que chamam atenção:",
        type: "list",
        list: [
          "• Mulheres com CA de mama prevalente e as portadoras de BRCA1 ou BRCA2 não foram mais pontuais no acompanhamento do que mulheres com baixo risco de CA;",
          "• Os principais fatores relacionados ao atraso na rodada de rastreamento foram os relacionados ao protocolo de rastreamento, ao invés de fatores relacionados a características da mulher ou fatores contextuais.",
        ],
      },
      {
        text: Post13Image2,
        type: "image",
      },
      {
        text: "Como implicações, indica-se que estratégias para melhorar aderência deveriam focar no processo de rastreamento, por exemplo, com envio de lembretes ou criando interações entre o time e as participantes do programa de rastreamento.",
        type: "text",
      },
      {
        text: "Acesse aqui o artigo completo para leitura:",
        type: "link",
        link: "https://academic.oup.com/oncolo/article/29/8/e967/7639123?login=false",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 14,
    title: "Ensaios clínicos randomizados vs. evidência de mundo real",
    description:
      "Não há novidade quanto à constante discussão sobre o papel e o espaço da evidência de mundo real em comparação com ensaios clínicos randomizados na avaliação de efeitos positivos e negativos de medicamentos e outras intervenções.",
    cover: Post14Image1,
    paragraphs: [
      {
        text: "Não há novidade quanto à constante discussão sobre o papel e o espaço da evidência de mundo real em comparação com ensaios clínicos randomizados na avaliação de efeitos positivos e negativos de medicamentos e outras intervenções.",
        type: "text",
      },
      {
        text: "Inspirados por um painel discutindo a 'mágica' da randomização vs. o 'mito' da evidência de mundo real, publicado há alguns anos no NEJM, pesquisadores associados à European Medicines Agency (EMA) publicaram um artigo abordando o impacto das mudanças na natureza dos produtos em saúde, o avanço da medicina de precisão e como o futuro da avaliação de novos produtos não é sobre escolher entre ECR e RWE, mas sobre a sua combinação. ",
        type: "text",
      },
      {
        text: "Destacamos o gráfico central do estudo, que conceitualiza as complexidades das questões de pesquisa relacionadas a uma droga hipotética para o tratamento de uma condição de saúde causada por diferentes mutações em pacientes individuais. ",
        type: "text",
      },
      {
        text: "Esse gráfico representa essas complexidades em três dimensões: largura, profundidade e contexto das informações; e apresenta a relação dessas dimensões com o desenho de estudo que seria necessário ou mais indicado para gerar a informação.",
        type: "text",
      },
      {
        text: "No texto do artigo são apresentados exemplos de vida real para essas relações.",
        type: "text",
      },
      {
        text: Post14Image1,
        type: "image",
      },
      {
        text: "Acesse aqui o texto completo:",
        type: "link",
        link: "https://ascpt.onlinelibrary.wiley.com/doi/10.1002/cpt.2083",
      },
      {
        text: "Acesse aqui o painel sobre ECR vs. RWE do NEJM:",
        type: "link",
        link: "https://www.nejm.org/doi/abs/10.1056/NEJMsb1901642",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 15,
    title: "Evidências acessíveis para todos",
    description:
      "Neste vídeo, comentamos um pouco a repercussão que uma de nossas metodologias de análise de RWE está tendo junto à sociedade brasileira.",
    cover: Post15Image1,
    paragraphs: [
      {
        text: "Neste vídeo, comentamos um pouco a repercussão que uma de nossas metodologias de análise de RWE está tendo junto à sociedade brasileira.",
        type: "text",
      },
      {
        text: "Esses resultados, para doença pulmonar obstrutiva crônica (DPOC), foram divulgados ao público no 41º Congresso Brasileiro de Pneumologia e Tisiologia, 17º Congresso Brasileiro de Endoscopia Respiratória e 13º Congresso Luso-Brasileiro de Pneumologia e também chamaram a atenção da mídia convencional:",
        type: "text",
      },
      {
        text: "Acesse aqui reportagem na Veja Saúde:",
        type: "link",
        link: "https://saude.abril.com.br/medicina/dupilumabe-novo-medicamento-para-dpoc-e-lancado-no-brasil/",
      },
      {
        text: "Acesse aqui reportagem na Viva Bem Uol:",
        type: "link",
        link: "https://www.uol.com.br/vivabem/noticias/redacao/2024/10/08/aposentadorias-precoces-dpoc.amp.htm",
      },
      {
        text: "Acesse aqui reportagem na Medicina S/A:",
        type: "link",
        link: "https://medicinasa.com.br/aposentadorias-dpoc/",
      },
      {
        text: "https://youtube.com/shorts/aD055d9ijPo",
        type: "video",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
  {
    id: 16,
    title:
      "Formando bases de RWD - abordagens de compartilhamento de dados sensíveis",
    description:
      "Dados biomédicos são gerados e coletados em múltiplas fontes. O compartilhamento desses dados para pesquisa pode ajudar na abordagem de necessidades não atendidas, no desenvolvimento científico para informar políticas de saúde.",
    cover: Post16Image1,
    paragraphs: [
      {
        text: "Dados biomédicos são gerados e coletados em múltiplas fontes. O compartilhamento desses dados para pesquisa pode ajudar na abordagem de necessidades não atendidas, no desenvolvimento científico para informar políticas de saúde.",
        type: "text",
      },
      {
        text: "No entanto, conforme descrito na nossa Lei Geral de Proteção de Dados (LGPD), dados de saúde, genéticos, biométricos e outros são considerados dados sensíveis, com necessidade de infraestrutura segura e segura com soluções adequadas de armazenamento.",
        type: "text",
      },
      {
        text: "Nossa indicação de leitura da semana inclui uma análise comparativa entre duas abordagens de compartilhamento de dados, a centralizada e a federada, através do prisma de cinco exemplos de repositórios de compartilhamento de dados de mundo real em grande escala no contexto europeu: French Health Data Hub, BBMRI-ERIC Colorectal Cancer Cohort, European Genome-phenome Archive, Observational Medical Outcomes Partnership/OHDSI network e EBRAINS Medical Informatics Platform, incluindo descrição da composição e estrutura dessas bases, assim como a forma de acesso aos dados.",
        type: "text",
      },
      {
        text: Post16Image1,
        type: "image",
      },
      {
        text: "Texto completo disponível aqui:",
        type: "link",
        link: "https://pmc.ncbi.nlm.nih.gov/articles/PMC11151787/",
      },
    ],
    user: "Karlyse Belli",
    date: "01/07/2024",
  },
];
